// Framework endpoint bindings. Mirrors iOS FrameworksEndpoints + /frameworks/*.
import { api } from "./client";
import type {
  FrameworkCost,
  FrameworkPipelinePreview,
  FrameworkRead,
  StartInputs,
} from "./create-types";

export function listFrameworks(): Promise<FrameworkRead[]> {
  return api.get<FrameworkRead[]>("/frameworks/");
}

export function getFramework(slug: string): Promise<FrameworkRead> {
  return api.get<FrameworkRead>(`/frameworks/${encodeURIComponent(slug)}`);
}

export function estimateCost(
  slug: string,
  startInputs: StartInputs,
  headteacherResponse?: Record<string, unknown>,
): Promise<FrameworkCost> {
  return api.post<FrameworkCost>(`/frameworks/${encodeURIComponent(slug)}/estimate-cost`, {
    start_inputs: startInputs,
    headteacher_response: headteacherResponse ?? null,
  });
}

export function previewSteps(
  slug: string,
  startInputs: StartInputs,
): Promise<FrameworkPipelinePreview> {
  return api.post<FrameworkPipelinePreview>(
    `/frameworks/${encodeURIComponent(slug)}/preview-steps`,
    { start_inputs: startInputs },
  );
}
